import {init} from 'modules/init'
import {createMap} from 'modules/map'

document.addEventListener('DOMContentLoaded', () => {
  // create map
  window.gameMap = createMap()
  init()
})
